import { useContext } from 'react';

import { default as UIMessageProvider, OpenUIMessage } from '../components/UIMessageProvider';

const useUIMessage = (): OpenUIMessage => useContext(UIMessageProvider.Context);

export default useUIMessage;
